"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _VideoPlayer = babelHelpers.interopRequireDefault(require("VideoPlayer"));

var _animationHelper = babelHelpers.interopRequireDefault(require("animation-helper"));

var _ProfileImageContainer = babelHelpers.interopRequireDefault(require("components/ProfileImageContainer"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _temp;

var PersonHeaderBlock = (_class = (_temp =
/*#__PURE__*/
function (_Block) {
  babelHelpers.inherits(PersonHeaderBlock, _Block);

  function PersonHeaderBlock() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, PersonHeaderBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(PersonHeaderBlock)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "headerBackground", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "videoSource", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "profileImage", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "fullName", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "icons", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "title", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "subTitle", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "location", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "footerIsBio", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "footerIsFollow", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "canFollow", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "following", _descriptor12, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "bioTarget", _descriptor13, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "linkTitle", _descriptor14, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "personId", _descriptor15, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "links", _descriptor16, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      ready: false
    };
    return _this;
  }

  babelHelpers.createClass(PersonHeaderBlock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      babelHelpers.get(babelHelpers.getPrototypeOf(PersonHeaderBlock.prototype), "componentDidMount", this).call(this);
      this.setState({
        ready: true
      });
    }
  }, {
    key: "toggleFollow",
    value: function toggleFollow() {
      require('following')[this.following ? 'doUnfollow' : 'doFollow'](this.personId, this.fullName);
    }
  }, {
    key: "scrollToBio",
    value: function scrollToBio() {
      var els = [document.documentElement, document.bpdy];
      var start = els.map(function (el) {
        return el.scrollTop;
      });
      var target = $(document.querySelector("[data-block-id=\"".concat(this.bioTarget, "\"]"))).offset().top;
      var delta = start.map(function (start) {
        return target - start;
      });
      var A = new _animationHelper.default(500, 'ease-in', function (percent) {
        els.forEach(function (el, i) {
          return el.scrollTop = start[i] + percent * delta[i];
        });
      });
      A.start();
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      return _react.default.createElement("div", {
        key: "bio",
        className: _classList.default.join('large-header', this.headerBackground && 'variable-background'),
        style: _base.default.styleForBackgroundObject(this.headerBackground)
      }, _react.default.createElement("div", {
        className: "bg-overlay"
      }), _react.default.createElement("div", {
        className: _classList.default.join('inner-content header', this.videoSource && 'with-video', this.profileImage && 'with-photo', this.state.ready && 'animate-fadeUp animate-fadeIn')
      }, this.videoSource && _react.default.createElement("div", {
        className: "video-player"
      }, _react.default.createElement(_VideoPlayer.default, {
        lazy: this.videoSource
      })), _react.default.createElement("div", {
        className: _classList.default.join('instructor-info', 'with-photo')
      }, _react.default.createElement(_ProfileImageContainer.default, {
        componentName: "div",
        className: "instructor-profile-image",
        noImageClassName: "initials",
        image: this.profileImage,
        name: this.fullName
      }), _react.default.createElement("div", null, _react.default.createElement("h1", {
        className: "title"
      }, this.fullName, this.icons.length > 0 && _react.default.createElement("span", {
        className: "account-icon-list"
      }, this.icons.map(function (icon) {
        return _react.default.createElement("img", {
          key: icon.id,
          className: "account-icon",
          src: icon.icon,
          title: icon.title
        });
      }))), this.title && _react.default.createElement("h3", null, this.title), this.subTitle && _react.default.createElement("h2", {
        className: "details"
      }, this.subTitle), this.location && _react.default.createElement("h2", {
        className: "details"
      }, this.location), !!(this.links.length + this.icons.length) && _react.default.createElement("div", {
        className: "instructor-icons"
      }, this.links.length > 0 && _react.default.createElement("span", {
        className: "account-link-list"
      }, this.links.map(function (_ref) {
        var id = _ref.id,
            linkUrl = _ref.linkUrl,
            type = _ref.type,
            title = _ref.title;
        return _react.default.createElement("a", {
          className: "account-link",
          href: linkUrl,
          target: "_blank",
          "data-link-type": type
        }, _react.default.createElement("span", null, title));
      })), this.icons.length > 0 && _react.default.createElement("span", {
        className: "account-icon-list"
      }, this.icons.map(function (icon) {
        return _react.default.createElement("img", {
          key: icon.id,
          className: "account-icon",
          src: icon.icon,
          title: icon.title
        });
      }))), this.footerIsFollow && this.canFollow && _react.default.createElement("a", {
        href: "javascript:void(0)",
        className: _classList.default.join('linkURL btn-secondary', this.following ? 'unfollow' : 'follow'),
        onClick: this.toggleFollow
      }, this.following ? 'Unfollow' : 'Follow'), this.footerIsBio && this.bioTarget && _react.default.createElement("a", {
        href: "javascript:void(0)",
        className: "linkURL btn-secondary",
        onClick: this.scrollToBio
      }, this.linkTitle)))));
    }
  }]);
  return PersonHeaderBlock;
}(_base.default), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "headerBackground", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "videoSource", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "profileImage", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "fullName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "icons", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "subTitle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "location", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "footerIsBio", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "footerIsFollow", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "canFollow", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "following", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "bioTarget", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "linkTitle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "personId", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "links", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "toggleFollow", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "toggleFollow"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "scrollToBio", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "scrollToBio"), _class.prototype)), _class);
exports.default = PersonHeaderBlock;